import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
    // configs
    sectionId='fixed-variable-annuities-intro'
    moduleName='intro-module'
    moduleVariation='A'
    // content
    headingText={<>How do annuities work as part of a <WidowBlock>financial plan&#63;</WidowBlock></>}
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='button'>
          Whatever you dream of when it comes to retirement, making sure you&#39;ll have the money to make it happen is an important part of your financial plan. Fewer companies offer pensions these days. And the future of Social Security is uncertain. Now, more than ever, people have to rely on themselves to plan for their finances in retirement. A fixed or variable deferred annuity can be a smart way to keep your retirement goals on track. You can save and grow your money, tax&#45;deferred, over and above what you can save by maxing out your contributions to your 401(k) or IRA.
        </Typography>
        <Link
          id='fixed-variable-annuities-intro-cta-fafa'
          variant='buttonLinkPrimary'
          themeType='lightTheme'
          linkUrl='/find-a-financial-advisor/'>
          Connect with an advisor
        </Link>
      </>
    )}
  />
);
